import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M9.31032 2.06738C9.56775 2.06742 9.79639 2.23168 9.87868 2.47559L14.0047 14.7148L17.2761 11.165C17.9122 10.4752 18.9871 10.4308 19.6775 11.0664L22.1824 13.374C22.8728 14.0102 22.9169 15.0859 22.281 15.7764L18.0974 20.3174H19.9724C20.3866 20.3174 20.7224 20.6532 20.7224 21.0674C20.7224 21.4816 20.3866 21.8174 19.9724 21.8174H15.9724C15.6078 21.8172 15.4326 21.7425 15.1756 21.5059L12.3709 18.998C11.6806 18.3618 11.6372 17.2861 12.2732 16.5957L12.7263 16.1035L11.8054 13.6836H5.2527L3.62087 18.8672H2.60036C2.19255 18.867 1.90349 18.4687 2.03005 18.0811L7.13356 2.48047C7.21428 2.23405 7.44457 2.0675 7.70388 2.06738H9.31032ZM13.3758 17.6123C13.3009 17.6936 13.3063 17.8207 13.3875 17.8955L15.8924 20.2021C15.9736 20.2767 16.0998 20.2716 16.1746 20.1904L17.1599 19.1191L14.3621 16.541L13.3758 17.6123ZM18.6619 12.1699C18.5807 12.0951 18.4536 12.1006 18.3787 12.1816L15.1746 15.6582L17.9734 18.2363L21.1775 14.7598C21.2521 14.6785 21.2468 14.5523 21.1658 14.4775L18.6619 12.1699ZM5.73317 12.1953H11.325L8.49294 3.3877L5.73317 12.1953Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ClearFormattingIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'clearFormatting')) as IconWithRender;

ClearFormattingIcon.displayName = 'ClearFormattingIcon';
ClearFormattingIcon.propTypes = Icon.propTypes;
ClearFormattingIcon.renderIcon = (props) => <ClearFormattingIcon {...props} />;
export default ClearFormattingIcon;
